import React from "react";
import "./Birthdays.css";
import { birthdays } from "./userData";

const TomorrowBirthdays = () => {
  const style = {
    width: "100%",
    height: "40px",
    backgroundColor: "#444444",
    borderRadius: "5px",
    padding: "0 10px",
    cursor: "pointer",
    margin: "10px 0px",
    transition: "background-color 0.1s ease-in-out",
  };
  function changeBackground(e) {
    e.target.style.background = "#6cf";
  }
  function defaultBackground(e) {
    e.target.style.background = "#444444";
  }
  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  var nextDate = tomorrow.getDate();
  var month = tomorrow.getMonth() + 1;

  const value = birthdays.filter(
    (date) => date.birthMonth === month && date.birthDate === nextDate
  );

  if (value.length === 0) {
    var statusMsg = "No Birthdays To Display...!";
  } else {
    statusMsg = "";
  }

  return (
    <div className="list">
      <div>
        <h1 className="status">{statusMsg}</h1>
      </div>
      {value.map((person) => {
        return (
          <h4
            onMouseOver={changeBackground}
            onMouseLeave={defaultBackground}
            key={person.name}
            style={style}
            className="pName"
          >
            ~ {person.name}
          </h4>
        );
      })}
    </div>
  );
};

export default TomorrowBirthdays;
